import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { ManageUsersSidebar } from "../adminDashboard/sidebar/sidebar.jsx";
import { Tab, Tabs } from "react-bootstrap";
 
import Table from "../adminDashboard/Table";
import Loader from "../../Loader";
import Dialog from "../../Dialog";
import { MDBIcon, toast, ToastContainer } from "mdbreact";
import DialogBenef from "../../DialogBenef";
import {
  getPlansv2,
  getOrders,
  setUsers,
  getUsers,
  getCookie,
  getPaises,
  enviarWspV2,
  getValoresXDominio,
  enviarMailV2,
  getMensajes,
  getEstadoReserva,
  getClienteByCIV2,
  getProductosByClienteV2,
  cancelaReserva,
  getProductosByCliente,
  getReservasByCliente,
  decodeToken,
  generateTempToken,
  validateForm,
  find,
  getDays,
  getMonths,
  getYears,
} from "../../functions.js";
import { API_CONFIG } from "../../../../Config/config-env.js";

import ReactExport from "react-export-excel-xlsx-fix";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

var fecNum = Date.now();
var fecNum2 = Date.now() + 1;

var f = new Date();
var fromDate = new Date();
fromDate.setDate(f.getDate() - 3);

var mes =
  f.getUTCMonth() + 1 < 10 ? "0" + (f.getUTCMonth() + 1) : f.getUTCMonth() + 1;
var dia = f.getUTCDate() < 10 ? "0" + f.getUTCDate() : f.getUTCDate();
var date_label = f.getUTCFullYear() + "." + mes + "." + dia;

class ManageUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: 1,
      bookings: [],
      action: "create",
      token_to_delete: "",
      date_label: date_label,
      loaded: false,
      v_days: [],
      v_months: [],
      v_years: [],
      paises: [],
      v_days_T: [],
      v_months_T: [],
      v_years_T: [],
      estadoscivil: [
        { text: "SOLTERO(A)", value: "SOLTERO(A)" },
        { text: "CASADO(A)", value: "CASADO(A)" },
        { text: "VIUDO(A)", value: "VIUDO(A)" },
        { text: "DIVORCIADO(A)", value: "DIVORCIADO(A)" },
      ],
      buttonsModalB: [
        {
          buttonAction: this.addPatient,
          buttonId: 1,
          buttonClass: "btn btn-success btn-sm",
          buttonName: "Guardar Datos",
        },
      ],
      id: 0,
      invalidForm: false,
      validation_B: [
        {
          name: "benef_ci_cliente",
          label: "Carnet de Identidad del Beneficiario",
          invalid: false,
          type: "number",
          maxLength: 12,
          minLength: 5,
        },
        {
          name: "benef_user_name",
          label: "Nombre del Beneficiario",
          invalid: false,
          type: "text",
        },
        {
          name: "benef_last_name",
          label: "Apellido del Beneficiario",
          invalid: false,
          type: "text",
        },
        {
          name: "benef_day",
          label: "Dia de Nacimiento del Beneficiario",
          invalid: false,
          type: "text",
        },
        {
          name: "benef_month",
          label: "Mes de Nacimiento del Beneficiario",
          invalid: false,
          type: "text",
        },
        {
          name: "benef_year",
          label: "A\u00F1o de Nacimiento del Beneficiario",
          invalid: false,
          type: "number",
        },
        {
          name: "benef_expedicion",
          label: "Expedici\u00F3n del Beneficiario",
          invalid: false,
          type: "text",
          notRequired: true,
        },
        { name: "benef_pais", label: "Pais", invalid: false, type: "text" },
        { name: "benef_ciudad", label: "Ciudad", invalid: false, type: "text" },
        {
          name: "benef_parentesco",
          label: "Parentezco",
          invalid: false,
          type: "text",
        },
        {
          name: "benef_estadocivil",
          label: "Estado Civil",
          invalid: false,
          type: "text",
        },
      ],
      customerDocumentId: 0,
      RadioReservationType: 0,
      customerName: "",
      customerId: 0,
      redirect: false,
      productId: 0,
      birthDate: null,
      bookingName: "",
      lockInputs: false,
      buttonLabel: "Crear Paciente",
      products: [],
      titulo: (
        <>
          {" "}
          <i className="fas fa-plus" /> Nuevo Paciente{" "}
        </>
      ),
      servicios: [],
      canales: [],
      users: [],
      segundo_nombre: "",
      canal: "",
      validations: {
        paciente: false,

        apellido_paterno: false,
        apellido_materno: false,
        primer_nombre: false,
        //segundo_nombre  : false,
        cedula: false,
        estado: false,
        valor1: false,
        valor2: false,
      },
      parentescos: [
        { text: "Esposa", value: "Esposa" },
        { text: "Esposo", value: "Esposo" },
        { text: "Hijo", value: "Hijo" },
        { text: "Hija", value: "Hija" },
        { text: "Hermano", value: "Hermano" },
        { text: "Hermana", value: "Hermana" },
      ],
      v_extension_T: [
        { text: "BE", value: "BE" },
        { text: "CB", value: "CB" },
        { text: "LP", value: "LP" },
        { text: "OR", value: "OR" },
        { text: "PD", value: "PD" },
        { text: "PT", value: "PT" },
        { text: "SC", value: "SC" },
        { text: "CH", value: "CH" },
        { text: "TJ", value: "TJ" },
        { text: "N/A", value: "" },
      ],
      tableData: {
        columns: [
          {
            dataIndex: "id",
            title: "Action",
            render: (text, record) => (
              <div style={{ width: 33 }}>
                <button
                  className="btn btn-sm btn-info"
                  id={record.id}
                  name="view"
                  onClick={this.editarPaciente}
                  type="submit"
                >
                  <i className="fas fa-edit" />
                </button>
              </div>
            ),
          },

          { dataIndex: "apellido_paterno", title: "Apellido Paterno" },
          { dataIndex: "apellido_materno", title: "Apellid Materno" },
          { dataIndex: "primer_nombre", title: "Primer Nombre" },
          { dataIndex: "segundo_nombre", title: "Segundo Nombre" },
          { dataIndex: "cedula", title: "Cedula Identidad" },
          { dataIndex: "desc_estado", title: "Estado" },
          { dataIndex: "fecha_creacion", title: "Fecha Creacion" },
          { dataIndex: "desc_paciente_registro", title: "Paciente Registro" },
        ],
        rows: [],
      },

      estados: [
        { value: "", text: "TODOS" },
        { value: "PAGADO", text: "PAGADO" },
        { value: "FACTURADO", text: "FACTURADO" },
        { value: "PENDIENTE", text: "PENDIENTE" },
        { value: "ERROR", text: "ERROR" },
      ],
      tipo_pago: "",
      tipos_pago: [
        { value: "", text: "TODOS" },
        { value: "QR", text: "QR" },
        { value: "Efectivo", text: "PAGO EN EFECTIVO" },
        { value: "CYBER", text: "TARJETA DE DEBITO/CREDITO" },
      ],

      desde: fromDate,
      hasta: new Date(),
      servicio: "",
      productsNV: [],
      customerAge: 0,
      validityProduct: "",
      productName: "",
      modal1: false,
      repartidores: [],
      repartidor: "",
      hoy: new Date(),
      paciente: "",
      contrasenia: "",
      apellido_paterno: "",
      apellido_materno: "",
      primer_nombre: "",
      cedula: "",
      estado: "1",
      Cod_Empresa: "",
      Cod_Ciudad: "",
      Cod_Oficina: "",
      valor1: "Vendedor",
      valor2: "",
      etiqueta1n: "Primer Nombre",
      etiqueta2n: "Segundo Nombre",
      etiqueta1a: "Primer Apellido",
      etiqueta2a: "Segundo Apellido",
      etiqueta1c: "Cod_Empresa",
      etiqueta2c: "Cod_Oficina",
      buttonsModalCancel: [
        {
          buttonAction: this.cancelaReserva,
          buttonId: 1,
          buttonClass: "btn btn-outline-danger btn-sm",
          buttonName: "Cancelar Reserva",
        },
      ],
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  toggleB = (event) => {
    this.setState({
      ["modalB"]: !this.state["modalB"],
    });
  };

  toggleB = (event) => {
    this.setState({
      ["modalB"]: !this.state["modalB"],
    });
  };

  onClickRadioGen_B = (nr) => () => {
    //console.log("change", nr)
    this.setState({
      benef_radioGenero: nr,
    });
  };

  changeHandler_B = async (event) => {
    var field_value = event.target.value;
    var field_name = event.target.name;
    //console.log(field_value)
    var respVal = validateForm(
      this.state.validation_B,
      this.state,
      toast,
      field_name,
      field_value
    );
    this.setState({
      ...this.state,
      [event.target.name]:
        event.target.name === "benef_email"
          ? event.target.value
          : event.target.value.toUpperCase(),
      validation_B: respVal.validation,
    });

    if (event.target.name == "benef_pais") {
      if (event.target.value != "BOLIVIA") {
        console.log("no es");
        setTimeout(
          function () {
            this.setState({ ...this.state, benef_ciudad: "" });
          }.bind(this),
          10
        );
      } else {
        setTimeout(
          function () {
            this.setState({ ...this.state, benef_ciudad: "Beni" });
          }.bind(this),
          10
        );
      }
    }
  };

  editarPaciente = async (event) => {
    let id = event.target.id;
    if (id === "") {
      id = event.target.parentNode.id;
    }

    let validations = this.state.validations;
    let pos = find(this.state.users, id, "id");
    let data = this.state.users[pos];

    //	validations["contrasenia"] =false
    for (let i in Object.keys(data)) {
      let field = Object.keys(data)[i];
      console.log(field, data[field]);

      if (field === "valor1") {
        if (data[field] === "Consultorio") {
          this.setState({
            etiqueta1n: "Nombre Consultorio",
            etiqueta2n: "Dirección Consultorio",
            etiqueta1a: "Nombre Doctor",
            etiqueta2a: "Apellido Doctor",
            etiqueta1c: "Cod_DBClinic",
            etiqueta2c: "Cod_SAP",
          });
        } else if (data[field] === "Monitor") {
          this.setState({
            etiqueta1n: "Nombre Monitor",
            etiqueta2n: "Dirección Monitor",
            etiqueta1a: "Nombre Monitor",
            etiqueta2a: "Apellido Monitor",
            etiqueta1c: "Cod_DBClinic",
            etiqueta2c: "Cod_SAP",
          });
        } else if (data[field] === "Doctor") {
          this.setState({
            etiqueta1n: "Primer Nombre",
            etiqueta2n: "Segundo Nombre",
            etiqueta1a: "Primer Apellido",
            etiqueta2a: "Segundo Apellido",
            etiqueta1c: "Cod_DBClinic",
            etiqueta2c: "Cod_SAP",
          });
        } else {
          this.setState({
            etiqueta1n: "Primer Nombre",
            etiqueta2n: "Segundo Nombre",
            etiqueta1a: "Primer Apellido",
            etiqueta2a: "Segundo Apellido",
            etiqueta1c: "Cod_Empresa",
            etiqueta2c: "Cod_Oficina",
          });
        }
      }
      if (data[field]) {
        this.setState({
          [field]: data[field],
        });

        validations[field] = data[field].length === 0;
      } else {
        console.log(field + ",");
      }
    }

    this.setState({
      validations: validations,
      action: "edit",
      buttonLabel: "Editar Paciente",
      lockInputs: true,
      id: id,
      titulo: (
        <>
          {" "}
          <i className="fas fa-edit" />
          Editar Paciente{" "}
        </>
      ),
      invalidForm: false,
    });
  };

  showAddBeneficiario = (event) => {
    this.setState({
      modalB: true,
      benef_edit: -1,
    });
  };

  clearData = async (event) => {
    let validations = {};
    let titulo = (
      <>
        {" "}
        <i className="fas fa-plus" /> Nuevo Paciente{" "}
      </>
    );
    let valor1 = "Vendedor";
    let valor2 = this.state.canales[0]?.value;
    this.setState({
      validations: validations,
      action: "create",
      buttonLabel: "Crear Paciente",
      lockInputs: false,
      titulo: titulo,

      id: 0,
      paciente: "",
      //contrasenia :"",
      apellido_paterno: "",
      apellido_materno: "",
      primer_nombre: "",
      segundo_nombre: "",
      cedula: "",
      estado: "1",
      Cod_Empresa: "",
      Cod_Ciudad: "",
      Cod_Oficina: "",
      valor1: valor1,
      valor2: valor2,
      etiqueta1n: "Primer Nombre",
      etiqueta2n: "Segundo Nombre",
      etiqueta1a: "Primer Apellido",
      etiqueta2a: "Segundo Apellido",
      etiqueta1c: "Cod_Empresa",
      etiqueta2c: "Cod_Oficina",
      //invalidForm:true,
    });
  };

  saveData = async (event) => {
    //console.log(this.state.action)

    let data = {
      paciente: false,
      apellido_paterno: false,
      apellido_materno: false,
      primer_nombre: false,
      //segundo_nombre  : false,
      cedula: false,
      estado: false,
      valor1: false,
      valor2: false,
    };

    let formData = {
      id: this.state.id,
      username: this.state.userInfo.id,
      action: this.state.action,
    };

    //console.log(data, Object.keys(data))

    var isValid = true;
    for (let i in Object.keys(data)) {
      let field = Object.keys(data)[i];
      //	console.log(field, this.state[field])
      /*
		if (this.state[field]==="" && field!== "contrasenia" ){
			
			data[field] = true
			isValid=false
		}else{
			formData[field] = this.state[field]
		}
    */
    }

    if (this.state.action === "create") {
      /*if (this.state.contrasenia.toString().length<8  ){
			data["contrasenia"] = true
			isValid=false
			toast.error("La contrase\u00F1a debe tener al menos 8 d\u00EDgitos", { closeButton: true });
		}
    */
    }

    if (this.state.etiqueta2n !== "Dirección Monitor") {
      if (isNaN(this.state.cedula)) {
        data["cedula"] = true;
        isValid = false;
        toast.error("Carnet inv\u00E1lido, solo se permiten n\u00FAmeros", {
          closeButton: true,
        });
      } else {
        if (this.state.cedula.toString().length < 5) {
          data["cedula"] = true;
          isValid = false;
          toast.error(
            "Carnet inv\u00E1lido, longitud m\u00EDnima 5 d\u00EDgitos",
            { closeButton: true }
          );
        }
      }
    } else {
      if (this.state.primer_nombre !== "") {
        isValid = true;
        formData["apellido_paterno"] = "-";
      } else {
        isValid = false;
        toast.error("Complete el nombre de Monitor", { closeButton: true });
      }
    }

    //formData["contrasenia"] = this.state.contrasenia

    if (isValid) {
      //formData["Cod_Ciudad"] = this.state.Cod_Ciudad;
      //formData["Cod_Empresa"] = this.state.Cod_Empresa;
      //formData["Cod_Oficina"] = this.state.Cod_Oficina;
      formData["segundo_nombre"] = this.state.segundo_nombre;

      this.setState({ ...this.state, isExecuting: true });

      var respI = await setUsers(formData);
      console.log(respI);

      if (respI.success) {
        var resp = await getUsers();

        resp.users.map(function (key) {
          let desc_estado = "Activo";
          if (key.estado === 1) {
            desc_estado = "Inactivo";
          }
          key["desc_estado"] = desc_estado;
        });

        const tableData = this.state.tableData;
        tableData.rows = resp.users ? resp.users : [];

        this.setState({ ...this.state, isExecuting: false, users: resp.users });
        this.clearData();
        toast.success("Datos registrados correctamente", { closeButton: true });
      } else {
        toast.error(respI.messsage, { closeButton: true });
        this.setState({ ...this.state, isExecuting: false });
      }
      //
    } else {
      this.setState({
        validations: data,
      });
    }
  };

  changeHandler = async (event) => {
    let value = event.target.value;
    let validations = this.state.validations;
    if (event.target.name === "paciente") {
      value = value.replaceAll(" ", "");
      value = value.toLowerCase();
    }
    if (event.target.name === "valor1") {
      if (event.target.value === "Consultorio") {
        this.setState({
          etiqueta1n: "Nombre Consultorio",
          etiqueta2n: "Dirección Consultorio",
          etiqueta1a: "Nombre Doctor",
          etiqueta2a: "Apellido Doctor",
          etiqueta1c: "Cod_DBClinic",
          etiqueta2c: "Cod_SAP",
        });
      } else if (event.target.value === "Monitor") {
        this.setState({
          etiqueta1n: "Nombre Monitor",
          etiqueta2n: "Dirección Monitor",
          etiqueta1a: "Nombre Monitor",
          etiqueta2a: "Apellido Monitor",
          etiqueta1c: "Cod_DBClinic",
          etiqueta2c: "Cod_SAP",
        });
      } else if (event.target.value === "Doctor") {
        this.setState({
          etiqueta1n: "Primer Nombre",
          etiqueta2n: "Segundo Nombre",
          etiqueta1a: "Primer Apellido",
          etiqueta2a: "Segundo Apellido",
          etiqueta1c: "Cod_DBClinic",
          etiqueta2c: "Cod_SAP",
        });
      } else {
        this.setState({
          etiqueta1n: "Primer Nombre",
          etiqueta2n: "Segundo Nombre",
          etiqueta1a: "Primer Apellido",
          etiqueta2a: "Segundo Apellido",
          etiqueta1c: "Cod_Empresa",
          etiqueta2c: "Cod_Oficina",
        });
      }
    }

    validations[event.target.name] = value.length === 0;

    this.setState({
      [event.target.name]: value,
      validations: validations,
    });

    if (
      this.state.paciente !== "" &&
      this.state.apellido_paterno !== "" &&
      this.state.apellido_materno !== "" &&
      this.state.primer_nombre !== "" &&
      //this.state.segundo_nombre !=="" &&
      this.state.cedula !== "" &&
      this.state.estado !== ""
    ) {
      console.log("valid");
      /*
		if (this.state.action==="create"){
			if(this.state.contrasenia!==""){
				this.setState({
					invalidForm:false
					});
			}
		}else{
			this.setState({
				invalidForm:false
			 });
		}
		*/
    }
  };
  handleSelect(key) {
    this.setState({ key });
  }
  onClickRadioReservationType = (nr, serviceId, key) => () => {
    this.setState({
      ...this.state,
      RadioReservationType: nr,
    });
    const bookings = this.state.bookings;
    for (var i in bookings) {
      if (bookings[i].id_servicio === serviceId) {
        bookings[i].llaves[key].serviceType = nr;
      }
    }
  };

  componentDidMount = async () => {
    this.setState({ isExecuting: true });

    let token = getCookie("tokenINNOVA2");
    var paises = getPaises();
    let esAdmin = true;
    var _resp;
    if (!token) {
      esAdmin = false;
    } else {
      _resp = await decodeToken(token);

      if (
        _resp.datos.rol === "Administrado" 
      ) {
        esAdmin = true;
      } else {
        esAdmin = false;
      }
    }

    if (!esAdmin) {
      this.setState({ redirect: true, isExecuting: false });
    } else {
      var userInfo = _resp.datos;
      this.setState({ userInfo: userInfo });
      var rol = userInfo.rol;
      var canal = userInfo.canal;
      var canales = [];
      var resp = await getUsers();

      resp.users.map(function (key) {
        let desc_estado = "Activo";
        if (key.estado === 1) {
          desc_estado = "Inactivo";
        }
        key["desc_estado"] = desc_estado;
      });

      const tableData = this.state.tableData;
      tableData.rows = resp.users ? resp.users : [];

      var respC = await getValoresXDominio("canales");
      let valor2 = "";
      respC.rows.map(function (key, index) {
        canales.push({ text: key.nombre, value: key.nombre });
        if (index === 0) {
          valor2 = key.nombre;
        }
      });

      console.log(respC, valor2);
      var v_days = getDays();
      var v_months = getMonths();
      var v_years = getYears();
      this.setState({
        ...this.state,
        loaded: true,
        users: resp.users,
        canales: canales,
        canal: canal,
        //servicios: servicios,
        //servicio:servicio,
        isExecuting: false,
        valor2: valor2,
        modalB: false,
        paises: paises,
        v_days: v_days,
        v_months: v_months,
        v_years: v_years,
        v_days_T: v_days,
        v_months_T: v_months,
        v_years_T: v_years,
      });
    }
  };
  toggleM = (nr) => () => {
    this.setState({
      ["modal" + nr]: !this.state["modal" + nr],
    });
  };

  render() {
    return (
      <>
        {this.state.redirect ? <Redirect to={{ pathname: "/" }} /> : ""}

        <div>
          <div className="breadcrumb-bar">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-md-12 col-12">
                  <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/home">Inicio</Link>
                      </li>
                    </ol>
                  </nav>
                  <h2 className="breadcrumb-title">
                    Administraci&oacute;n de Pacientes
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <Loader idLoading={this.state.isExecuting} />

          <div className="content">
            <ToastContainer
              hideProgressBar={true}
              newestOnTop={false}
              position={"bottom-right"}
              autoClose={3000}
            />
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-lg-5 col-xl-4 theiaStickySidebar">
                  <div className="row">
                    <div className="col-12">
                      <div className="col-12">
                        <span className="h3-responsive ">
                          {this.state.titulo}
                        </span>
                      </div>
                    </div>
                  </div>
                  <span className="or-line" />
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <label>Codigo Paciente</label>
                        <input
                          name="paciente"
                          disabled={this.state.lockInputs}
                          className={
                            "form-control " +
                            (this.state.validations.paciente
                              ? "is-invalid"
                              : "")
                          }
                          type="text"
                          value={this.state.paciente}
                          onChange={this.changeHandler}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      {/*
											<div className="form-group mini-margin card-label">
												<label>Contraseña*</label>
												<input
													name="contrasenia"
													disabled={this.state.lockInputs_}
													className={"form-control " + (this.state.validations.contrasenia ? "is-invalid" : "")}
													type="text" value={this.state.contrasenia} onChange={this.changeHandler} />
											
											</div>
                       */}
                    </div>
                  </div>

                  {this.state.etiqueta2n !== "Dirección Monitor" && (
                    <>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group mini-margin card-label">
                            <label>{this.state.etiqueta2n}</label>
                            <input
                              name="segundo_nombre"
                              className={
                                "form-control " +
                                (this.state.validations.segundo_nombre_
                                  ? "is-invalid"
                                  : "")
                              }
                              type="text"
                              value={this.state.segundo_nombre}
                              onChange={this.changeHandler}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group mini-margin card-label">
                            <label>{this.state.etiqueta1a}</label>
                            <input
                              name="apellido_paterno"
                              className={
                                "form-control " +
                                (this.state.validations.apellido_paterno
                                  ? "is-invalid"
                                  : "")
                              }
                              type="text"
                              value={this.state.apellido_paterno}
                              onChange={this.changeHandler}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group mini-margin card-label">
                            <label>{this.state.etiqueta2a}</label>
                            <input
                              name="apellido_materno"
                              className={
                                "form-control " +
                                (this.state.validations.apellido_materno
                                  ? "is-invalid"
                                  : "")
                              }
                              type="text"
                              value={this.state.apellido_materno}
                              onChange={this.changeHandler}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="row">
                    {this.state.etiqueta2n !== "Dirección Monitor" && (
                      <div className="col-6">
                        <div className="form-group mini-margin card-label">
                          <label>C&eacute;dula de Identidad</label>
                          <input
                            name="cedula"
                            className={
                              "form-control " +
                              (this.state.validations.cedula
                                ? "is-invalid"
                                : "")
                            }
                            type="text"
                            value={this.state.cedula}
                            onChange={this.changeHandler}
                          />
                        </div>
                      </div>
                    )}
                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <label>Estado</label>
                        <select
                          name="estado"
                          className={
                            "form-control " +
                            (this.state.validations.estado ? "is-invalid" : "")
                          }
                          onChange={this.changeHandler}
                          value={this.state.estado}
                          defaultValue={this.state.estado}
                        >
                          <option value={"1"}>Activo</option>
                          <option value={"2"}>Inactivo</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-3 mb-3">
                    {/*	
									<div className="col-12">

										<span style={{fontSize:14, fontWeight:600}}>*Si deja la contrase&ntilde;a en blanco no se actualizar&aacute; </span>
									</div>
                  */}
                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <button
                          className="btn btn-info btn-block"
                          name="search"
                          onClick={this.clearData}
                          type="submit"
                        >
                          Limpiar Formulario
                        </button>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <button
                          className="btn btn-primary btn-block"
                          name="search"
                          onClick={this.showAddBeneficiario}
                          disabled={this.state.invalidForm}
                          type="submit"
                        >
                          {this.state.buttonLabel}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="atenciones" className="col-md-6 col-lg-7 col-xl-8">
                  <div className="card">
                    <div className="card-body pt-0">
                      <div
                        id="results"
                        className="col-12 col-lg-12 text-right mb-2 mt-3"
                        style={{ padding: 0 }}
                      >
                        <ExcelFile
                          filename={"export-ordenes." + this.state.date_label}
                          element={
                            <button
                              disabled={this.state.tableData.rows.length == 0}
                              type="button"
                              className="btn btn-sm btn-success"
                              name="set"
                            >
                              {" "}
                              Exportar
                            </button>
                          }
                        >
                          <ExcelSheet
                            data={this.state.tableData.rows}
                            name="ordenes"
                          >
                            <ExcelColumn label="Paciente" value="paciente" />
                            <ExcelColumn label="Rol" value="valor1" />
                            <ExcelColumn label="Canal" value="valor2" />
                            <ExcelColumn
                              label="Apellido Materno"
                              value="apellido_paterno"
                            />
                            <ExcelColumn
                              label="Apellido Paterno"
                              value="apellido_materno"
                            />
                            <ExcelColumn
                              label="Primer Nombre"
                              value="primer_nombre"
                            />
                            <ExcelColumn
                              label="Segundo Nombre"
                              value="segundo_nombre"
                            />
                            <ExcelColumn
                              label="Cedula Identidad"
                              value="cedula"
                            />
                            <ExcelColumn label="Estado" value="desc_estado" />
                            <ExcelColumn
                              label="Fecha Creacion"
                              value="fecha_creacion"
                            />
                            <ExcelColumn
                              label="Paciente Registro"
                              value="desc_paciente_registro"
                            />
                          </ExcelSheet>
                        </ExcelFile>
                      </div>

                      <Table tableData={this.state.tableData} />

                      <DialogBenef
                        open={this.state.modalB}
                        icon="fas fa-plus"
                        cancelButton={true}
                        toggle={this.toggleB}
                        title="Datos del Paciente"
                        validation_B={this.state.validation_B}
                        v_extension_T={this.state.v_extension_T}
                        v_days_T={this.state.v_days_T}
                        v_months_T={this.state.v_months_T}
                        v_years_T={this.state.v_years_T}
                        paises={this.state.paises}
                        ciudades={this.state.ciudades}
                        parentescos={this.state.parentescos}
                        benef_radioGenero={this.state.benef_radioGenero}
                        changeHandler_B={this.changeHandler_B}
                        onClickRadioGen_B={this.onClickRadioGen_B}
                        benef_extension={this.state.benef_extension}
                        benef_expedicion={this.state.benef_expedicion}
                        benef_ci_cliente={this.state.benef_ci_cliente}
                        benef_id_cliente={this.state.benef_id_cliente}
                        benef_user_name={this.state.benef_user_name}
                        benef_last_name={this.state.benef_last_name}
                        benef_last_name_2={this.state.benef_last_name_2}
                        benef_email={this.state.benef_email}
                        benef_phone={this.state.benef_phone}
                        benef_day={this.state.benef_day}
                        benef_month={this.state.benef_month}
                        benef_year={this.state.benef_year}
                        benef_direccion={this.state.benef_direccion}
                        benef_ciudad={this.state.benef_ciudad}
                        benef_pais={this.state.benef_pais}
                        benef_parentesco={this.state.benef_parentesco}
                        benef_ocupacion={this.state.benef_ocupacion}
                        benef_estadocivil={this.state.benef_estadocivil}
                        estadoscivil={this.state.estadoscivil}
                        buttons={this.state.buttonsModalB}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default ManageUsers;
